import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {

    text$: Observable<BreadcrumbServiceText> = new BehaviorSubject<BreadcrumbServiceText>(undefined);
    buttons$: Observable<BreadcrumbServiceButton[]> = new BehaviorSubject<BreadcrumbServiceButton[]>([]);

    reset() {
        this.text = undefined;
        this.resetButtons();
    }

    resetButtons() {
        this.buttons = [];
    }

    set text(text: BreadcrumbServiceText) {
        (this.text$ as BehaviorSubject<BreadcrumbServiceText>).next(text);
    }

    addButton(button: BreadcrumbServiceButton) {
        console.log('add button', button);
        const buttons = (this.buttons$ as BehaviorSubject<BreadcrumbServiceButton[]>).value;
        buttons.push(button);
        this.buttons = buttons;
    }

    set buttons(buttons: BreadcrumbServiceButton[]) {
        console.log('set buttons', buttons);
        console.trace('Breadcrumb buttons updated');
        (this.buttons$ as BehaviorSubject<BreadcrumbServiceButton[]>).next(buttons);
    }
}

export class BreadcrumbServiceText {
    text: string;
    path: string;
}

export class BreadcrumbServiceButton {
    id: string;
    iconName?: string;
    imageUrl?: string;
    onClick: () => void;
}